class ObjectKeyConverter {
  static snakeToCamel(obj) {
    if (!obj) return obj;
    switch (typeof obj) {
      case 'object':
        Object.keys(obj).forEach(key => {
          const camelKey = key.replace(/([_][a-z])/ig, ($1) => $1.toUpperCase().replace('_', ''));
          const value = this.snakeToCamel(obj[key]);
          if (key !== camelKey) {
            obj[camelKey] = value;
            delete obj[key];
          }
        });
        return obj;
      default:
        return obj;
    }
  }

  static camelToSnake(obj) {
    if (!obj) return obj;
    switch (typeof obj) {
      case 'object':
        Object.keys(obj).forEach(key => {
          const snakeKey = key.replace(/[A-Z]/g, ($1) => '_' + $1.toLowerCase());
          const value = this.camelToSnake(obj[key]);
          if (key !== snakeKey) {
            obj[snakeKey] = value;
            delete obj[key];
          }
        });
        return obj;
      default:
        return obj;
    }
  }
}

module.exports = ObjectKeyConverter;



// WEBPACK FOOTER //
// ./src/libs/utils/object_key_converter.js